import SearchEngineAdapter from 'Services/Adapters/SearchEngineBeta/SearchEngineAdapter';
import { v4 as uuidv4 } from 'uuid';

export default class ContactAdapter extends SearchEngineAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'contact';
    }

    constructor(data = [], query = '') {
        super(data, query);
        this.key = ContactAdapter._key;
    }

    getStructure() {
        return {
            key: this.key,
            label: window.i18n.__('Contact'),
            count: 0,
            items: [],
            filters: ['contact'],
        };
    }

    formatCompanies(companies) {
        return companies.map((company) => {
            return {
                name: this.checkFieldForQuery(company.name),
                link: `/companies/${company.id}`,
            };
        });
    }

    formatItem(item) {
        return {
            id: item.object.id,
            name: this.checkFieldForQuery(item.first_name + ' ' + item.last_name),
            companies: item.companies.length > 0 ? this.formatCompanies(item.companies) : [],
            position: item.position,
            link: `/peoples/${item.object.id}`,
            component: 'search-result-contact',
            uuid: uuidv4(),
            highlightedExtraFields: [
                {
                    label: window.i18n.__('Tél. :'),
                    value: this.checkFieldForQuery(item.phone_number, true),
                },
                {
                    label: window.i18n.__('Port. :'),
                    value: this.checkFieldForQuery(item.mobile_number, true),
                },
                {
                    label: window.i18n.__('Fax :'),
                    value: this.checkFieldForQuery(item.fax_number, true),
                },
                {
                    label: window.i18n.__('Email :'),
                    value: this.checkFieldForQuery(item.email, true),
                },
                {
                    label: window.i18n.__('Adr. de facturation :'),
                    value: this.checkFieldForQuery(
                        this.formatAddress(item.invoicing_address),
                        true,
                    ),
                },
                {
                    label: window.i18n.__('Adr. de livraison :'),
                    value: this.checkFieldForQuery(this.formatAddress(item.delivery_address), true),
                },
            ],
        };
    }
}
